import React from 'react';
import Icon from '@atlaskit/icon';
import { useIntl } from '@atlassian/jira-intl';
import flagDisabledIconUrl from './assets/flag-disabled.svg';
import flagEnabledIconUrl from './assets/flag-enabled.svg';
import messages from './messages.tsx';

const size = 'medium';

const FlagDisabledGlyph = () => <img src={flagDisabledIconUrl} alt="" />;

export const FlagDisabledIcon = () => {
	const { formatMessage } = useIntl();
	return (
		<Icon
			testId="software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.icons.disabled"
			size={size}
			glyph={FlagDisabledGlyph}
			label={formatMessage(messages.flagDisabledIconLabel)}
		/>
	);
};

const FlagEnabledGlyph = () => <img src={flagEnabledIconUrl} alt="" />;

export const FlagEnabledIcon = () => {
	const { formatMessage } = useIntl();
	return (
		<Icon
			testId="software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.icons.enabled"
			size={size}
			glyph={FlagEnabledGlyph}
			label={formatMessage(messages.flagEnabledIconLabel)}
		/>
	);
};
